import { IUser } from '@app/models/User'
import { List, Record } from 'immutable'
import { ChatRecipient, IChatRecipient } from './ChatRecipient'
import { IMessage, Message } from './Message'

export interface IChat {
  readonly deleted: boolean
  readonly group: List<IChatRecipient>
  readonly messages: List<IMessage>
  readonly hasArchived: List<string>
  readonly lastMessageTimestamp?: number
}

const ChatRecord = Record({
  deleted: false,
  group: List<ChatRecipient>(),
  hasArchived: List<string>(),
  lastMessageTimestamp: undefined,
  messages: List<Message>(),
})

export class Chat extends ChatRecord implements IChat {
  public static fromJS(initialState?: Partial<IChat>) {
    if (!initialState) {
      return new Chat()
    }
    const { group, hasArchived, messages, ...rest } = initialState
    return new Chat({
      group: group ? List(group.map((a) => ChatRecipient.fromJS(a))) : undefined,
      hasArchived: List(hasArchived || []),
      messages: messages
        ? List(messages.map((a) => Message.fromJS(a)))
        : undefined,
      ...rest,
    })
  }

  public static getRecipientList(chat: IChat, user?: IUser) {
    let title = ''

    const group = chat.group.filter((item: any) => {
      if (user) {
        return item.contactId !== user.id
      } else {
        return true
      }
    })

    if (group) {
      title = group.first().name

      if (group.size === 2) {
        title += ` and ${group.skip(1).first().name}`
      } else {
        for (let i = 1; i < group.size; i++) {
          const name = group.skip(i).first().name

          if (i === group.size - 1) {
            title += `, and ${name}`
          } else {
            title += `, ${name}`
          }

          if (i > 1 && group.size - 1 - i > 0) {
            title += `, + ${group.size - 1 - i} more...`
            i = group.size
          }
        }
      }
    }

    return title
  }

  public readonly deleted: boolean
  public readonly group: List<ChatRecipient>
  public readonly messages: List<Message>
  public readonly hasArchived: List<string>
  public readonly lastMessageTimestamp?: number

  constructor(initialState?: Partial<Chat>) {
    initialState ? super(initialState) : super()
  }
}
